import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import {connect} from "react-redux";
import {
  creatingScenarioProjcetsSet,
  saveName,
  projectErrorsObjSet,
  creatingScenarioFinStrSet,
  setDealRoomFinSchemaErrorsObjectsCreating
} from "../../../store/actions";


class ScenarioCreateModal extends React.Component {
  state = {
    modal: false,
    errors: {},
    name: '',
  };

  handleChange = event => {
    const {errors} = this.state;
    const  name = event.target.value;
    if (name) {
      this.setState({name});
    } else {
      this.setState({name, errors: {...errors, name: 'Field is requierd'}});
    }
  };

  handleClick = () => {
    const {name, errors} = this.state;
    const {
      saveName, modalType,
      choosenProjects, creatingScenarioProjcetsSet,
      toggle, projectErrorsObjSet,
      onFinStrcheckbox, creatingScenarioFinStrSet,
      setDealRoomFinSchemaErrorsObjectsCreating
    } = this.props;

    let flag = false;
    let err = errors;
    if (!name) {
      flag = true;
      err.name = "Field is requierd";
    } else {
      err.name = "";
    }

    this.setState({errors: err});
    if (!flag) {
      saveName(name);
      if (modalType === 'project') {
        creatingScenarioProjcetsSet(choosenProjects, true);
        toggle();
        projectErrorsObjSet(choosenProjects.length);
      } else {
        creatingScenarioFinStrSet(onFinStrcheckbox, true);
        toggle();
        setDealRoomFinSchemaErrorsObjectsCreating(1);
      }
    }
  };

  render() {
    const {isOpen, className, toggle} = this.props;
    const {name, errors} = this.state;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={this.toggle}
          className={className}
        >
          <ModalHeader toggle={this.toggle}>Add new asset scheme</ModalHeader>
          <ModalBody>
            <CardBody>
              <Row>
                <Col xs="8">
                  <FormGroup onSubmit={() => {
                  }}>
                    <Label htmlFor="name">Set a name</Label>
                    <Input
                      type="text"
                      id="name"
                      value={name}
                      placeholder="Enter your name"
                      onChange={this.handleChange}
                      required
                    />
                    {errors.name && <p style={{color: 'red'}}>{errors.name}</p>}
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleClick}>
              Add
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>

        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dealroomProjects: state.dealroom.dealroomProjects,
    dealroomfinancicalSchemas: state.financicalSchemas.res && state.financicalSchemas.res.results,
  }
};

export default connect(
  mapStateToProps,
  {creatingScenarioProjcetsSet, saveName, projectErrorsObjSet, creatingScenarioFinStrSet, setDealRoomFinSchemaErrorsObjectsCreating}
)(ScenarioCreateModal);




// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/ScenarioCreateModal.js